import React from 'react';
import { Carousel } from "react-bootstrap";
import { Link } from "react-router-dom";
import OptimisedImage from '../../../SharedComponents/OptimisedImage';

function CAROUSEL_ITEM(link, img, caption) {
  return(
    <>
      <div className="imgContainer">
        <Link to={link}>
          <OptimisedImage
            alt="Carousel front image"
            image={img}
          />
        </Link>
      </div>
      <Carousel.Caption>{caption}</Carousel.Caption>
    </>
  );
}

class CustomCarousel extends React.Component {
  render() {
    return(
      <div className="c">
        <Carousel>
          <Carousel.Item>
            {CAROUSEL_ITEM("/bioenergy-in-the-uk/maps", require("../../BioEnergyInTheUK/maps/__assets__/WinterWheatStraw_StretchedTiff.png"), "Where in the UK can we find Biomass?")} 
          </Carousel.Item>
          <Carousel.Item>
            {CAROUSEL_ITEM("/case-studies", require("../images/__assets__/caseStudies.png"), "What does research say about Bioenergy?")}
          </Carousel.Item>
          <Carousel.Item>
            {CAROUSEL_ITEM("/bioenergy-in-the-uk/graphs", require("../../BioEnergyInTheUK/graphs/__assets__/renewable_heat.png"), "How is Bioenergy currently used in the UK?")}
          </Carousel.Item>
          <Carousel.Item>
            {CAROUSEL_ITEM("/ghg-calculator", require("../images/__assets__/calculator.png"), "What are the Greenhouse Gas emissions of various Bioenergy applications?")}
          </Carousel.Item>
        </Carousel>
      </div>
    );
  }
}

export default CustomCarousel;